function createSvg(node, name) {
    const useNode = document.createElement('use');

    useNode.setAttribute('xlink:href', `/sprite.svg#${name}`);
    node.appendChild(useNode);
}

export {createSvg};
